export const actionTypes = {
  CHANGE_TAB: "CHANGE_TAB",
  CHANGE_SIDE_BAR: "CHANGE_SIDE_BAR",
  CHANGE_FACILITY: "CHANGE_FACILITY",
  ADD_USER: "ADD_USER",
  SEARCH_USER: "SEARCH_USER",
  REFRESH_MONITOR: "REFRESH_MONITOR",
  REFRESH_USER: "REFRESH_USER",
  REFRESH_FACILITY: "REFRESH_FACILITY",
  SEARCH_MONITOR: "SEARCH_MONITOR",
  SEARCH_BAR: "SERACH_BAR",
  MONITOR_DETAILS: "MONITOR_DETAILS",
  FACILITY_DETAILS: "FACILITY_DETAILS",
  USER_MANUAL: "USER_MANUAL",
  NAV_FUNCTION: "NAV_FUNCTION",
  FACILITYLIST_REFRESH: "FACILITYLIST_REFRESH",
  FACILITY_NAME: "FACILITY_NAME",
  SEARCH_FACILITY: "SEARCH_FACILITY",
  REFRESH_ASSOCIATE: "REFRESH_ASSOCIATE",
  DELETE_AUDIO: "DELETE_AUDIO",
  CALL_AUDIOGRID: "CALL_AUDIOGRID",
  REFRESH_AUDIO: "REFRESH_AUDIO",
  MONITORLIST_REFRESH: "MONITORLIST_REFRESH",
  USERLIST_REFRESH: "USERLIST_REFRESH"
};
